<template>
    <div v-if="$store.state.stats.curr_users>0" class="stats">
        <div>
            <h3>{{$store.state.stats.new_subs}}</h3>
            <span>subscriptions created within 31 days</span>
        </div>
        <div>
            <h3>{{$store.state.stats.curr_users}}</h3>
            <span>users currently registered</span>
        </div>
        <div>
            <h3>{{$store.state.stats.cases}}</h3>
            <span>Customer cases</span>
        </div>
        <div>
            <h3>{{$store.state.stats.active_subs}}</h3>
            <span>active subscriptions</span>
        </div>
        <div>
            <h3>{{$store.state.stats.susp_users}}</h3>
            <span>suspended accounts</span>
        </div>
        <div>
            <h3>{{$store.state.stats.invoices}}</h3>
            <span>Customer invoices</span>
        </div>
    </div>
    <Loading v-else/>
</template>
<script>
import Loading from '@/components/parts/Loading.vue';

export default {
    name: 'Stats',
    components: {Loading},
    data() {
        return {
            
        }
    },
    methods: {
        getStats: function(){
            var vue = this;
            this.$socket.client.emit('getStats',null, (error, response) => {
                if(error=='200'){
                    vue.$store.state.stats = response;
                }
            })
        }
    },
    mounted() {
        this.getStats();
    },
}
</script>
<style scoped lang="scss">
    .stats{
        width: 100%;
        min-height: 300px;
        margin-bottom: 2rem;
        display: flex;
        flex-wrap: wrap;

        & > div{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 3rem 1rem;
            flex: 1 1 400px;
            flex-basis: 33%;
            min-width: 230px;
        }
        text-align: center;
        h3{
            font-size: 4rem;
            margin: 0;
        }
        span{
            font-size: 1rem;
            display: block;
            margin: auto;
        }
    }
</style>